module.exports = __webpack_public_path__ + "static/img/4.128a711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R141B/4.jpg
// module id = 4TiR
// module chunks = 1